import { Badge } from "@devhop/ui";
import type { PrivateLessonPackageKind } from "@/modules/private-lessons/domain/contracts/templates";
import { multiMemberPackageLabel } from "@/modules/private-lessons/domain/lib/package-kind";

type PrivateLessonGroupPackageBadgeProps = {
  packageKind?: PrivateLessonPackageKind;
  groupSize?: number | null;
};

export function PrivateLessonGroupPackageBadge({
  packageKind,
  groupSize,
}: PrivateLessonGroupPackageBadgeProps) {
  const label = multiMemberPackageLabel(packageKind);
  if (!label) return null;
  return (
    <Badge variant="outline" className="font-normal">
      {label}
      {groupSize != null ? ` (${groupSize} ຄົນ)` : ""}
    </Badge>
  );
}
